// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import bankPichinchaLogoSrc from './bank-pichincha.svg';
import bankGuayaquilLogoSrc from './bank-guayaquil.svg';

export const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  list-style: none;
`;

export const Item = styled.li`
  flex: 0 1 auto;
  margin: 10px 5px;
`;

export function Banks(): Node {
  return (
    <List>
      <Item>
        <img src={bankPichinchaLogoSrc} alt="Banco Pichincha Mi Vecino" />
      </Item>
      <Item>
        <img src={bankGuayaquilLogoSrc} alt="Banco Guayaquil" />
      </Item>
    </List>
  );
}
